import React, { useCallback, useRef, useState } from "react";
import {
  AppBar,
  Box,
  Button,
  Dialog,
  DialogContent,
  Icon,
  IconButton,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { useEffect } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import moment from "moment";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { MobileDateTimePicker } from "@mui/x-date-pickers/MobileDateTimePicker";
import dayjs from "dayjs";

export default function SiteVisitMeeting(props) {
  const { open, handleClose, handleSiteMeeting } = props;
  const [startValue, SetStartValue] = useState(dayjs(new Date()));
  const [endValue, SetEndValue] = useState(dayjs(new Date()));
  const [addressValue, SetAddressValue] = useState("");
  const [submitDisable, setSubmitDisable] = useState(true);
  useEffect(() => {
    if (startValue && endValue && addressValue) {
      setSubmitDisable(false);
    } else {
      setSubmitDisable(true);
    }
  }, [startValue, endValue, addressValue]);

  return (
    <>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
        <AppBar position="static">
          <Toolbar className="flex w-full justify-between">
            <Typography variant="subtitle1" color="inherit">
              Change Site Visit Meeting
            </Typography>
            <IconButton onClick={handleClose}>
              <Icon>close</Icon>
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent classes={{ root: "p-16 sm:p-24" }}>
          <Box sx={{ mb: 2 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              {/* <DateTimePicker
                renderInput={(props) => <TextField fullWidth {...props} />}
                label="Start Date & Time"
                value={startValue}
                onChange={(newValue) => {
                  SetStartValue(newValue.$d);
                }}
              /> */}
              <DemoContainer components={["MobileDateTimePicker"]}>
                <DemoItem>
                  <MobileDateTimePicker
                    label="Start Date & Time"
                    defaultValue={startValue}
                    onChange={(newValue) => {
                      SetStartValue(newValue.$d);
                    }}
                  />
                </DemoItem>
                <DemoItem>
                  <MobileDateTimePicker
                    label="End Date & Time"
                    defaultValue={endValue}
                    onChange={(newValue) => {
                      SetEndValue(newValue.$d);
                    }}
                  />
                </DemoItem>
              </DemoContainer>
            </LocalizationProvider>
          </Box>
          <Box sx={{ mb: 2 }}>
            {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DateTimePicker
                renderInput={(props) => <TextField fullWidth {...props} />}
                label="End Date & Time"
                value={endValue}
                onChange={(newValue) => {
                  SetEndValue(newValue.$d);
                }}
              />
            </LocalizationProvider> */}
          </Box>
          <Box sx={{ mb: 2 }}>
            <TextField
              label="Location"
              multiline
              fullWidth
              value={addressValue}
              onChange={(newValue) => {
                SetAddressValue(newValue.target.value);
              }}
            />
          </Box>
          <Button
            type="button"
            variant="contained"
            color="warning"
            size="large"
            disabled={submitDisable}
            onClick={() =>
              handleSiteMeeting(startValue, endValue, addressValue)
            }
          >
            Submit
          </Button>
        </DialogContent>
      </Dialog>
    </>
  );
}
